import { render, staticRenderFns } from "./generated-reports.vue?vue&type=template&id=710972a0"
import script from "./generated-reports.vue?vue&type=script&lang=js"
export * from "./generated-reports.vue?vue&type=script&lang=js"
import style0 from "./generated-reports.vue?vue&type=style&index=0&id=710972a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports